import { Button, Dialog, DialogActions, DialogTitle } from "@mui/material";
import { useMutationRemoveAddress } from "services/api/mutations/useMutationRemoveAddress";
import { IUserAddressInfo } from "types/Address";
import { UseQueryResult } from "react-query";
import { IShoppingBagData } from "../../types/ShoppingBag";

type Props = {
  open: boolean;
  handleCloseDialog: () => void;
  address: IUserAddressInfo;
  shoppingBagQuery: UseQueryResult<IShoppingBagData>
};

function DeleteAddressConfirmDialog({ open, handleCloseDialog, address, shoppingBagQuery }: Props) {
  const { mutateAsync: removeAddressAsync } = useMutationRemoveAddress();
  const confirmDelete = async () => {

    const request = {...address, current_shopping_bag_id: shoppingBagQuery.data?.id ?? -1}

    await removeAddressAsync(request);
   // handleCloseDialog();
  };
  return (
    <Dialog open={open} onClose={() => handleCloseDialog()} onBackdropClick={() => handleCloseDialog()}> 
      <DialogTitle id="confirm-dialog">
        Deseja realmente remover esse endereço?
      </DialogTitle>
      <DialogActions>
        <Button variant="outlined" onClick={() => handleCloseDialog()}>
          Não
        </Button>
        <Button
          variant="outlined"
          onClick={() => {
            handleCloseDialog();
            confirmDelete();
          }}
        >
          Sim
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteAddressConfirmDialog;
